export default __webpack_public_path__ + "static/media/nft-cal-thumbnail.6375490b.png";